import Alpine from "alpinejs";

const DOC = document;
const HTML = DOC.documentElement.classList;
const BODY = DOC.body.classList;
const CLASS_NAME = "overflow-hidden";

const overflow = (add) => {
    const CALL = add ? "add" : "remove";
    HTML[CALL](CLASS_NAME);
    BODY[CALL](CLASS_NAME);
};

document.addEventListener("alpine:init", () => {
    Alpine.directive("lock-scroll", (el, { expression }, { evaluate }) => {
        overflow(evaluate(expression));
    });
});
